import {useAnalytics} from '@github-ui/use-analytics'
import {Button, Label} from '@primer/react'
import {type RefObject, useCallback, useRef} from 'react'

import type {SuggestedChange} from '../../../conversation-types'

export function CommitOrRemoveFromBatch({
  onOpenDialog,
  pendingSuggestedChangesBatch,
}: {
  onOpenDialog: (returnFocusRef?: RefObject<HTMLElement>) => void
  pendingSuggestedChangesBatch: SuggestedChange[]
}) {
  const returnFocusRef = useRef<HTMLButtonElement>(null)
  const handleCommitBatchClick = useCallback(() => {
    onOpenDialog(returnFocusRef)
  }, [onOpenDialog])

  const batchCount = pendingSuggestedChangesBatch.length
  const {sendAnalyticsEvent} = useAnalytics()

  const handleRemoveFromBatchClick = useCallback(() => {
    // TODO: Implement when we add suggested changes batching
    // removeSuggestedChangeFromPendingBatch(suggestedChange)
    sendAnalyticsEvent('comments.remove_suggested_change_from_batch', 'REMOVE_SUGGESTED_CHANGE_FROM_BATCH_BUTTON')
  }, [sendAnalyticsEvent])

  return (
    <div className="d-flex flex-row flex-justify-between">
      <Label variant="attention" className="my-auto">
        Pending in batch
      </Label>
      <div className="d-flex gap-2">
        <Button size="medium" variant="danger" onClick={handleRemoveFromBatchClick}>
          Remove from batch
        </Button>
        <Button
          ref={returnFocusRef}
          size="medium"
          count={batchCount}
          variant="primary"
          onClick={handleCommitBatchClick}
        >
          {`Apply suggestion${batchCount > 1 ? 's' : ''}`}
        </Button>
      </div>
    </div>
  )
}

try{ CommitOrRemoveFromBatch.displayName ||= 'CommitOrRemoveFromBatch' } catch {}